import request from "../service/request"
let url = process.env.VUE_APP_BASE_URL // 正式接口地址
let testUrl = process.env.VUE_APP_BASE_URL_TEST //测试接口地址
function dynamicUrl(url) {
  if (url) {
    let exportUrl = '';
    Object.keys(url).map((key) => {
      exportUrl += key + '=' + url[key] + '&';
    })
    exportUrl = exportUrl.substring(exportUrl.length - 1, 0)
    return exportUrl;
  }
}
// 获取公司主体下拉
export const GetCompanyentity= ()=> request.get(testUrl+'/contractLock/companyList')
// 获取制式下拉选中的(查单个的)
export const GetContractPreviewData= (para)=> request.get(testUrl+'/contractLock/getContractPreviewData?'+dynamicUrl(para))
// 获取制式合同pdf
export const GetStandard= (para)=> request.post(testUrl+'/contractLock/templatePage',para)
// 获取制式合同参数
export const GetTemplateParametersList= (para)=> request.post(testUrl+'/contractLock/templateParametersList',para)

// 获取合同模板下拉
export const GetConttemplate= (para)=> request.post(testUrl+'/contractLock/categoryList',para)

// 保存制式合同
export const CreateStandardContract= (para)=> request.post(testUrl+'/contractLock/createStandardContract',para)

// 制式合同列表
export const GetContractInfo= (para)=> request.get(testUrl+'/contractLock/getContractInfoList?'+dynamicUrl(para))
// 删除合同
export const RemoveContract= (para)=> request.post(testUrl+'/contractLock/removeContract',para)
// 制式合同检查身份
export const CheckPerson= (para)=> request.get(testUrl+'/contractLock/qxAuth2check?'+dynamicUrl(para))
// 签约项目接口+报价类型下拉数据
export const GetCategoryTagList= ()=> request.get(testUrl+'/contractLock/categoryTagList')
// 特批类型下拉数据
export const GetSpecialTagList= (para)=> request.get(testUrl+'/contractLock/getSpecialTagList?'+dynamicUrl(para))
// 服务费收费标准下拉数据
export const GetServiceFeeList= (para)=> request.get(testUrl+'/contractLock/getServiceFeeList?'+dynamicUrl(para))
// 获取最后保存成功的合同信息中的公司名称和签约项目
export const GetNewContractData= (para)=> request.get(testUrl+'/contractLock/getNewContractData?'+dynamicUrl(para))
// 下载预览的合同
export const DownContractUrl = (para) =>
  request.get(testUrl + '/contractLock/downContractUrl?' + dynamicUrl(para), {
    responseType: 'blob'
  });
// 生成契约锁二维码
export const GetContractUrl = (para) =>
  request.get(testUrl + '/contractLock/getContractUrl?' + dynamicUrl(para));
// 获取协议内容数据
export const GetSupAgreementDropDown=(para)=> request.get(testUrl+'/contractLock/getSupAgreementDropDown?' + dynamicUrl(para))
// 校验协议内容数据
export const CheckSupAgreementByIds= (para)=> request.get(testUrl+'/contractLock/checkSupAgreementByIds?' + dynamicUrl(para))
// 获取契约锁附件OSS地址
export const GetAnnexOssUrl= (para)=> request.post(testUrl+'/contractLock/getAnnexOssUrl',para)
/* E 制式 2024-05-14*/

/* S 特批名额条款配置 2025-03-26*/
// 获取特批名额分类下拉数据
export const GetSpecialTagDropDown= ()=> request.get(testUrl+'/contractLock/getSpecialTagDropDown')
// 特批名额条款列表
export const getSupAgreementList= (para)=> request.get(testUrl+'/contractLock/getSupAgreementList?' + dynamicUrl(para))
// 添加特批名额条款
export const AddSupAgreement= (para)=> request.post(testUrl+'/contractLock/addSupAgreement',para)
// 修改特批名额条款
  export const EditSupAgreement= (para)=> request.post(testUrl+'/contractLock/editSupAgreement',para)
// 停用/启用特批名额条款
export const EditSupAgreementMainData= (para)=> request.post(testUrl+'/contractLock/editSupAgreementMainData',para)
// 删除特批名额条款
export const RemoveSupAgreement= (para)=> request.post(testUrl+'/contractLock/removeSupAgreement',para)
// 查看特批名额条款详情
//
export const getSupAgreement= (para)=> request.get(testUrl+'/contractLock/getSupAgreement?' + dynamicUrl(para))
/* E 特批名额条款配置 2025-03-26*/


/* S 非制式 2024-05-15*/
// 获取非制式下拉选中的+签署位置 /contractLock/getNonContractPreviewData
export const GetNonContractPreviewData= (para)=> request.get(testUrl+'/contractLock/getNonContractPreviewData?'+dynamicUrl(para))
//关键字索引下拉
export const GetKeyWordIndexList= ()=> request.get(testUrl+'/contractLock/getKeyWordIndexList')
// 签署类型下拉
export const GetSignatureTypeList= ()=> request.get(testUrl+'/contractLock/getSignatureTypeList')
// 保存非制式合同
export const CreateNonStandardContract= (para)=> request.post(testUrl+'/contractLock/createNonStandardContract',para)
/* E 非制式 2024-05-15*/

/* S 面试邀约 2025-05-27*/
// 公司主体下拉
export const GetSelectCompany= ()=> request.get(testUrl+'/interview/selectCompany')
// 城市下拉
export const GetSelectCity= ()=> request.get(testUrl+'/interview/selectCity')
// 面试邀约配置列表
export const GetSelectInterviewInvitation= (para)=> request.get(testUrl+'/interview/selectInterviewInvitation?' + dynamicUrl(para))
// 生成面试邀约二维码
export const GenerateQRCode= (para)=> request.post(testUrl+'/interview/generateQRCode',para)
// 添加面试邀约
export const AddInterviewInvitation= (para)=> request.post(testUrl+'/interview/addInterviewInvitation',para)
// 面试人员信息列表
export const GetSelectInterviewList= (para)=> request.get(testUrl+'/interview/selectInterviewerList?' + dynamicUrl(para))
// 添加、修改面试人员信息
export const SaveOrUpdateInterviewer= (para)=> request.post(testUrl+'/interview/saveOrUpdateInterviewer',para)
// 删除面试人员信息
export const RemoveInterviewer= (para)=> request.post(testUrl+'/interview/removeInterviewer',para)
// 判断双端

export const Getdevice= ()=> request.get(testUrl+'/interview/device')
/* E 面试邀约 2025-05-27*/

/* S 替换领导 2025-9-16 */
// 区域下拉
export const getRegionList = ()=> request.get(testUrl+'/erp/departureHandover/recruitmentRegionDropdown')
// 中心下拉
export const getSalesCenterDropdown = ()=> request.get(testUrl+'/erp/departureHandover/salesCenterDropdown')
// 部门下拉
export const getDepartmentDropdown = (para)=> request.get(testUrl+'/erp/departureHandover/departmentDropdown?' + dynamicUrl(para))
// 组别下拉
export const getGroupDropdown = (para)=> request.get(testUrl+'/erp/departureHandover/groupDropdown?' + dynamicUrl(para))
// 岗位下拉
export const getPositionDropdown = (para)=> request.get(testUrl+'/erp/departureHandover/positionDropdown?' + dynamicUrl(para))
// 原上级领导下拉
export const getPersonDropdown = ()=> request.get(testUrl+'/erp/departureHandover/personDropdown')
//列表
export const getPersonList = (para)=> request.get(testUrl+'/erp/departureHandover/personList?' + dynamicUrl(para))
// 替换
export const changePerson= (para)=> request.post(testUrl+'/erp/departureHandover/changePerson',para)
/* E 替换领导 2025-9-16 */

/* S 新契约合同配置改版 2025-12-2 */
// 合同类型下拉
export const getContractTypeList = ()=> request.get(testUrl+'/contractLock/crm/contractTemplate/typeDown')
// 合同模板下拉
export const getContractTemplateList = (para)=> request.get(testUrl+'/contractLock/crm/contractTemplate/templateDown?' + dynamicUrl(para))
// 合同模板详情
export const getContractTemplateDetailList = (para)=> request.get(testUrl+'/contractLock/crm/contractTemplate/detail?' + dynamicUrl(para))
// 特批名额下拉
export const getSpecialQuotaList = ()=> request.get(testUrl+'/contractLock/crm/specialQuota/typeDown')
// 创建预览合同
export const saveCreatePreview= (para)=> request.post(testUrl +'/contractLock/createContractDraft',para)
//合同数据回显
export const getViewContractData = (para)=> request.get(testUrl +'/contractLock/getContactTemplateList?' + dynamicUrl(para))
/* E 新契约合同配置改版 2025-12-2 */
/* S 特批条款配置 新 2025-12-4*/
// 特批名额条款列表
export const getNewSupAgreementList= (para)=> request.get(testUrl+'/contractLock/new/getSupAgreementList?' + dynamicUrl(para))
// 添加特批名额条款
export const AddNewSupAgreement= (para)=> request.post(testUrl+'/contractLock/new/addSupAgreement',para)
// 停用/启用特批名额条款
export const EditNewSupAgreementMainData= (para)=> request.post(testUrl+'/contractLock/new/editSupAgreementMainData',para)
// 查看特批名额条款详情
export const getNewSupAgreement= (para)=> request.get(testUrl+'/contractLock/new/getSupAgreement?' + dynamicUrl(para))
// 获取协议内容数据
export const GetNewSupAgreementDropDown=(para)=> request.get(testUrl+'/contractLock/new/getSupAgreementDropDown?' + dynamicUrl(para))
// 删除合同
export const RemoveNewContract= (para)=> request.post(testUrl+'/contractLock/newRemoveContract',para)
// 校验协议内容数据
export const CheckNewSupAgreementByIds= (para)=> request.get(testUrl+'/contractLock/new/checkSupAgreementByIds?' + dynamicUrl(para))
/* E 特批条款配置 新 2025-12-4*/
// 获取第一份合同参数
export const getCommonContractParam = (para)=> request.get(testUrl+'/contractLock/getCommonContractParam?' + dynamicUrl(para))
// 校验某流程下多个合同
export const getVerifyContractParameters = (para)=> request.post(testUrl+'/contractLock/verifyContractParameters',para)
// 虚拟资产集合
export const getVirtualAssetList = (para)=> request.get(testUrl+'/erp/virtualAsset/assetList?' + dynamicUrl(para))
//新媒体详情信息
export const getVirtualAsseDetail = (para)=> request.get(testUrl+'/erp/virtualAsset/media/detail?' + dynamicUrl(para))
// 获取计算依据下拉选
export const getCalculationBaseDropdown = (para)=> request.get(testUrl+'/erp/exchangeRate/calculationBaseDropdown?' + dynamicUrl(para))
//币种下拉选
export const getCurrencyDropdown = (para)=> request.get(testUrl+'/erp/exchangeRate/currencyDropdown?' + dynamicUrl(para))
// 汇率计算
export const getExchangeRateCalculation = (para)=> request.get(testUrl+'/erp/exchangeRate/exchangeRateCalculation?' + dynamicUrl(para))
// 合同模板下拉
export const getTemplateDropDown = ()=> request.get(testUrl+'/contractLock/templateDropDown')
// 签约项目
export const getProjectDropDown = ()=> request.get(testUrl+'/contractLock/projectDropDown')
// 公司主体
export const getContactTemplateList = (para)=> request.get(testUrl+'/contractLock/signCompanyDropDown?' + dynamicUrl(para))
// 合同保存
export const saveLifecycleCreateContractDraft= (para)=> request.post(testUrl+'/contractLock/lifecycleCreateContractDraft',para)
// 更新合同模板HTML
export const refreshContractTemplateHtml= (para)=> request.post(testUrl+'/contractLock/refreshContractTemplateHtml',para)
// 组件正则校验（转发至 CRM 后端）
export const validateComponents = (para)=> request.post(testUrl+'/contractLock/validateComponents',para)

/* S 绿通合同 */
// 合同列表
export const getGreenChannelList = (para)=> request.get(testUrl+'/greenChannel/list?' + dynamicUrl(para))
// 合同上传
export const ossUpload= (para)=> request.post(testUrl+'/greenChannel/uploadAndParse',para)
// 合同详情
export const getGreenChannelDetail = (para)=> request.get(testUrl+'/greenChannel/detail?' + dynamicUrl(para))
// 保存合同
export const createDraft= (para)=> request.post(testUrl+'/greenChannel/createDraft',para)
// 删除合同
export const removeDraft= (para)=> request.post(testUrl+'/greenChannel/remove',para)
// 查询合同上传进度
export const getGreenChannelProgress = (para)=> request.get(testUrl+'/greenChannel/progress?' + dynamicUrl(para))
// 获取最后保存成功的合同信息中的公司主体
export const getNewContractData = (para)=> request.get(testUrl+'/greenChannel/getNewContractData?' + dynamicUrl(para))
// 生成契约锁二维码
export const getGreenChanneContractUrl = (para) =>
    request.get(testUrl + '/greenChannel/getContractUrl?' + dynamicUrl(para));

/* E 绿通合同 */